export default {
  'user.profile.company': 'Empresa',
  'user.profile.position': 'Puesto',
  'user.profile.kicker.account': 'Cuenta',
  'user.profile.changePassword': 'Cambiar Contraseña',
  'user.profile.changePassword.summary':
    'Elige una contraseña distinta a la actual. La usarás la próxima vez que entres.',
  'user.profile.twoFactor': 'Habilitar Two-Factor',
  'user.profile.twoFactor.summary': 'Además de la contraseña, al entrar te pedimos un código.',
  'user.profile.twoFactor.explain': 'Te llega a tu correo electrónico o a tu teléfono celular.',
  'user.profile.twoFactor.toggle': 'Autenticación en dos pasos',
  'user.profile.twoFactor.status.on': 'Activa en tu cuenta',
  'user.profile.twoFactor.status.off': 'Desactivada en tu cuenta',
  'user.profile.pushNotifications': 'Notificaciones',
  'user.profile.currentPassword': 'Contraseña Actual',
  'user.profile.password': 'Nueva Contraseña',
  'user.profile.confirmPassword': 'Confirmar Contraseña',
  'user.profile.labelTwoFactor': '¿Autenticación Two-Factor Habilidata?',
  'user.profile.': ' ',

  'user.menu.logout': 'Cerrar sesión',
  'user.menu.options': 'Opciones',
  'user.menu.profile': 'Perfil',
  'user.menu.resetPassword': 'Cambiar contraseña',
  'user.menu.locales': 'Idiomas',
  'user.menu.environments': 'Entornos',
  'user.menu.companies': 'Empresas',

  'user.forgot.title': 'Olvidé mi contraseña',
  'user.forgot.sent': '¡Listo!',
  'user.forgot.description':
    'Ingresa tu correo electrónico y te enviaremos un mensaje para crear tu nueva contraseña',
  'user.forgot.sent.description':
    'Te hemos enviado un link a tu correo electrónico para que puedas crear una nueva contraseña.',

  'user.login.email.placeholder': 'tu@empresa.com',
  'user.login.password.placeholder': 'Ingresa tu contraseña',
  'user.login.newPassword.placeholder': 'Crea tu nueva contraseña',
  'user.login.confirmPassword.placeholder': 'Repite tu contraseña',
  'user.login.code.placeholder': 'Ingresa el código',

  'user.login.error.email.required': 'Por favor ingresa tu correo electrónico',
  'user.login.error.email.invalid': 'Ingresa un correo electrónico válido',
  'user.login.error.password.required': 'Por favor ingresa tu contraseña',
  'user.login.error.confirmPassword.required': 'Por favor confirma tu contraseña',
  'user.login.error.code.required': 'Por favor ingresa el código de verificación',

  'user.login.forgotPassword': 'Olvidé mi contraseña',
  'user.login.reset.hint':
    'Debe tener mínimo 8 caracteres, incluir mayúsculas y minúsculas, un número y un caracter especial "!#*$@%&?".',
  'user.login.reset.sent': 'Su nueva contraseña ha sido creada de manera exitosa.',
  'user.login.reset.title': 'Ingresa tu nueva contraseña',
  'user.login.reset.link.error.title': 'Error',
  'user.login.reset.link.error.description': 'El enlace para el cambio de contraseña no es válido.',

  'user.twoFactor.providers': 'Proveedores',
  'user.twoFactor.provider.email': 'Código de correo electrónico',
  'user.twoFactor.title': 'Enviar Código de Verificación',
  'user.twoFactor.description': 'Seleccione proveedor de autenticación Two-Factor',
  'user.twoFactor.code.title': 'Introduzca Código de Verificación',
  'user.twoFactor.alert.title': 'Listo!',
  'user.twoFactor.alert.description': 'Te hemos enviado un correo con el código de seguridad.',
  'user.twoFactor.error.send': 'Error al enviar el código de verificación. Inténtalo de nuevo.',
  'user.twoFactor.error.validate': 'Código de seguridad incorrecto. Inténtalo de nuevo.',

  'user.login.subtitle': 'O continúa con',
  'user.login.sso.success.title': 'Inicio de sesión exitoso',
  'user.login.sso.success.description': 'Has iniciado sesión correctamente.',
  'user.login.sso.success.badge': 'Sesión autorizada',
  'user.login.sso.success.redirect': 'Serás redirigido en {seconds}s…',

  'user.rpaAuth.product': 'AUTOMY RPA DESIGNER',
  'user.rpaAuth.title': 'Autenticación exitosa',
  'user.rpaAuth.description':
    'Puedes volver a la aplicación. Esta pestaña intentará cerrarse automáticamente.',
  'user.rpaAuth.badge': 'Sesión autorizada',
  'user.rpaAuth.manualCloseHint': 'Si la pestaña no se cierra, puedes cerrarla manualmente.',
  'user.rpaAuth.action.closeTab': 'Cerrar pestaña',
  'user.rpaAuth.browserBlockHint':
    'Algunos navegadores bloquean el cierre automático por seguridad.',
  'user.login.confirm.link.error.description': 'El enlace para confirmar su cuenta no es válido.',
  'user.login.banner.eyebrow': 'Hiperautomatización No-Code',
  'user.login.banner.title': 'Automatización que',
  'user.login.banner.titleAccent': 'trabaja por ti',
  'user.login.banner.description':
    'Crea flujos de trabajo, despliega agentes de IA y ejecuta bots RPA. Todo sin escribir una sola línea de código.',
  'user.login.banner.trust': 'La eligen empresas líderes en más de 10 países.',
  'user.login.banner.feature.workflows': 'Flujos de trabajo',
  'user.login.banner.feature.agents': 'Agentes de IA',
  'user.login.banner.feature.apps': 'Apps',
  'user.login.banner.feature.rpa': 'RPA',

  'user.login.legal.privacy': 'Política de privacidad',
  'user.login.legal.terms': 'Términos y condiciones',
  'user.login.legal.copyright': '© {year} AUTOMY GLOBAL CORP. Todos los derechos reservados.',

  'user.accessBlocked.title': 'Acceso temporalmente bloqueado',
  'user.accessBlocked.description':
    'Tu empresa no puede acceder a AUTOMY en este momento. Contacta a soporte o a un administrador para resolverlo.',
  'user.accessBlocked.code.companyInactive':
    'La empresa está inactiva y no puede acceder a AUTOMY.',
  'user.accessBlocked.code.subscriptionNotFound':
    'No se encontró una suscripción activa para la empresa.',
  'user.accessBlocked.code.pendingActivation':
    'La suscripción de la empresa está pendiente de activación.',
  'user.accessBlocked.code.pendingPayment': 'La suscripción de la empresa tiene un pago pendiente.',
  'user.accessBlocked.code.paymentMethodRequired':
    'Se requiere un método de pago para continuar. Vuelve a iniciar sesión para completar el proceso.',
  'user.accessBlocked.code.pastDue': 'La suscripción de la empresa tiene un pago vencido.',
  'user.accessBlocked.code.canceled': 'La suscripción de la empresa fue cancelada.',
  'user.accessBlocked.code.suspended': 'La suscripción de la empresa está suspendida.',
  'user.accessBlocked.action.contactSupport': 'Contactar soporte',
  'user.accessBlocked.action.contactAdmin': 'Entendido',
  'user.accessBlocked.action.relogin': 'Volver a iniciar sesión',
  'user.accessBlocked.action.backToLogin': 'Ir al inicio de sesión',
  'user.accessBlocked.billingReloginHint':
    'Para completar el pago o configurar el método de pago, inicia sesión de nuevo. El sistema te guiará con un acceso restringido.',
  'user.accessBlocked.contactAdminHint':
    'Un administrador de la empresa debe resolver el estado de facturación o suscripción.',

  'user.billingRecovery.title': 'Completa la configuración de facturación',
  'user.billingRecovery.title.setup': 'Configura tu método de pago',
  'user.billingRecovery.title.pay': 'Completa el pago de tu suscripción',
  'user.billingRecovery.action.setupPaymentMethod': 'Configurar método de pago',
  'user.billingRecovery.action.paySubscription': 'Pagar suscripción',
  'user.billingRecovery.secureBadge': 'Conexión segura',
  'user.billingRecovery.trustHint':
    'Serás redirigido a {stripe} para completar el proceso de forma segura. AUTOMY no almacena los datos de tu tarjeta.',
  'user.billingRecovery.loading': 'Preparando tu acceso seguro…',
  'user.billingRecovery.tokenExpired.title': 'Sesión de recuperación expirada',
  'user.billingRecovery.tokenExpired.description':
    'El acceso restringido expiró. Vuelve a iniciar sesión para continuar con la facturación.',
  'user.billingRecovery.error.stateChanged':
    'El estado de la suscripción cambió. Vuelve a iniciar sesión para actualizar la información.',
  'user.billingRecovery.error.paymentMethodRequired': 'Primero debes configurar un método de pago.',
  'user.billingRecovery.error.manualPayment': 'Esta suscripción requiere registrar un pago manual.',
  'user.billingRecovery.manualClaim.title': 'Registre su pago',
  'user.billingRecovery.manualClaim.description':
    'Reporte la transferencia o el pago manual. AUTOMY lo revisará antes de restaurar el acceso.',
  'user.billingRecovery.manualClaim.submittedTitle': 'Registro de pago enviado',
  'user.billingRecovery.manualClaim.submittedDescription':
    'AUTOMY está revisando su pago. No hay cambio de acceso hasta que se confirme. Puede iniciar sesión de nuevo más tarde.',
  'user.billingRecovery.taxExclusive.title': 'Precio de la suscripción (antes de impuestos)',
  'user.billingRecovery.error.actionNotAllowed':
    'Tu acceso actual no permite iniciar esta acción. Vuelve a iniciar sesión.',
  'user.billingRecovery.error.amountInvalid':
    'No se pudo resolver un monto válido para pagar la suscripción.',
  'user.billingRecovery.error.generic':
    'No se pudo iniciar el proceso de pago. Inténtalo de nuevo o vuelve a iniciar sesión.',
  'user.billingRecovery.result.successTitle': 'Proceso completado',
  'user.billingRecovery.result.successDescription':
    'Si el pago o la configuración se completaron, inicia sesión de nuevo para acceder a AUTOMY.',
  'user.billingRecovery.result.cancelTitle': 'Proceso cancelado',
  'user.billingRecovery.result.cancelDescription':
    'Cancelaste el proceso de pago. Puedes volver a iniciar sesión e intentarlo otra vez.',
  'user.billingRecovery.result.doneTitle': 'Listo',
  'user.billingRecovery.result.doneDescription': 'Inicia sesión de nuevo para continuar.',
  'user.billingRecovery.result.confirmingTitle': 'Estamos confirmando…',
  'user.billingRecovery.result.confirmingDescription':
    'Estamos verificando el resultado del pago con el proveedor. Esto puede tomar unos segundos.',
  'user.billingRecovery.result.cancelPendingDescription':
    'Estamos confirmando si el proceso se canceló o si el pago aún se está procesando.',
  'user.billingRecovery.result.pendingTimeoutTitle': 'Confirmación en curso',
  'user.billingRecovery.result.pendingTimeoutDescription':
    'Aún no recibimos la confirmación final. Puedes iniciar sesión de nuevo en unos minutos o reintentar.',
  'user.billingRecovery.result.setupCompletedTitle': 'Método de pago configurado',
  'user.billingRecovery.result.setupCompletedDescription':
    'Tu método de pago quedó guardado. Inicia sesión de nuevo para continuar; puede pedirse el pago de la suscripción.',
  'user.billingRecovery.result.setupCompletedNextDescription':
    'Tu método de pago quedó guardado. Estamos actualizando el estado de facturación para continuar con el pago.',
  'user.billingRecovery.result.confirmingMethodTitle': 'Confirmando método de pago…',
  'user.billingRecovery.result.confirmingMethodDescription':
    'Estamos confirmando tu método de pago. Esto puede tomar unos segundos; no cierres esta ventana.',
  'user.billingRecovery.result.confirmingMethodTimeoutTitle': 'Confirmación en curso',
  'user.billingRecovery.result.confirmingMethodTimeoutDescription':
    'Aún no se reflejó el método de pago. Puedes reintentar o volver a iniciar sesión.',
  'user.billingRecovery.result.accessAllowedTitle': 'Suscripción activa',
  'user.billingRecovery.result.accessAllowedDescription':
    'Tu suscripción ya está activa. Inicia sesión nuevamente para continuar.',
  'user.billingRecovery.result.paymentCompletedTitle': 'Pago de suscripción confirmado',
  'user.billingRecovery.result.paymentCompletedDescription':
    'El pago se confirmó. Inicia sesión de nuevo para acceder a AUTOMY.',
  'user.billingRecovery.result.failedTitle': 'No pudimos confirmar',
  'user.billingRecovery.result.failedDescription':
    'El proceso de pago no se completó. Puedes reintentar o volver a iniciar sesión.',
  'user.billingRecovery.result.expiredTitle': 'La sesión expiró',
  'user.billingRecovery.result.expiredDescription':
    'La sesión de pago expiró. Vuelve a intentarlo desde el inicio de sesión.',
  'user.billingRecovery.result.missingSessionTitle': 'Sesión de pago no encontrada',
  'user.billingRecovery.result.missingSessionDescription':
    'No encontramos el identificador de la sesión de pago. Vuelve a iniciar sesión e inténtalo de nuevo.',
  'user.billingRecovery.action.retry': 'Reintentar',

  'user.support.title': 'Contacta a soporte',
  'user.support.hint':
    'Si tu empresa no puede acceder por facturación o activación, el equipo de soporte puede ayudarte.',
};
